import React, { useEffect, useState } from "react";
import { Button } from "rizzui/button";
import { Text } from "rizzui/typography";
import { useModal } from "../../../hooks/useModal";
import DataTable from "../../../component/table";
import { phoneColumns } from "./column";
import DeleteNumber from "../../../component/deleteNumber";
import CreateNumber from "../../../component/createNumber";
import {
  useDeletePhone,
  useUserPhones,
} from "../../../hooks/useProfileDetails";
import { useQueryClient } from "@tanstack/react-query";
import { useNotifcication } from "../../../hooks/useNotification";
import MyLoader from "../../../component/loader";

export default function PhoneNumbers() {
  const { openModal } = useModal();
  const [currentId, setCurrentId] = useState("");
  const [shouldDelete, setShouldDelete] = useState(false);
  const { data, isLoading } = useUserPhones();
  const { refetch } = useDeletePhone({ id: currentId });
  const queryClient = useQueryClient();
  const { openNotification } = useNotifcication();

  const deletePhoneNumber = () => {
    refetch()
      .then((res) => {
        if (res?.data) {
          openNotification({
            status: "success",
            message: "Phone number deleted",
          });
          queryClient.invalidateQueries({ queryKey: ["user_phones"] });
        }
      })
      .catch((err) => {
        openNotification({
          status: "error",
          message: "Something went wrong, try again",
        });
        console.error(err);
      });
  };

  useEffect(() => {
    if (shouldDelete && currentId) {
      deletePhoneNumber();
      setShouldDelete(false); // Reset the trigger after the delete is initiated
    }
  }, [shouldDelete, currentId]);

  return (
    <div className="flex flex-col gap-4 mt-5">
      <Button
        className="!bg-btn h-[33px] w-fit px-[25px] py-[9px] rounded-[4px] self-end"
        onClick={() => openModal({ view: <CreateNumber /> })}
      >
        <Text className="font-switzer text-[12px] font-[400] text-background">
          Create new number
        </Text>
      </Button>
      {isLoading ? (
        <MyLoader />
      ) : (
        <div className="h-[calc(100vh-290px)]">
          <DataTable
            data={data?.data ?? []}
            columns={phoneColumns}
            meta={(row) => {
              return {
                handleClick: (row) =>
                  openModal({
                    view: (
                      <DeleteNumber
                        type="number"
                        deleteFunction={() => {
                          setCurrentId(row?.original?._id);
                          setShouldDelete(true);
                        }}
                      />
                    ),
                  }),
              };
            }}
            isLoading={false}
            setPage={() => {}}
            pageSize={null}
            error={null}
          />
        </div>
      )}
    </div>
  );
}
